import { LocationPointAddressType, LocationPointPolicy } from "@daytrip/legacy-enums";
import { Expose, Transform, Type } from "class-transformer";
import { IsBoolean, IsDefined, IsInt, IsString, IsUUID } from "class-validator";
import { v4 as uuid } from "uuid";

import { GField, GInt, GObjectType } from "../graphql";
import { CDBaseEntity, CDColumn, CDEntity, CDObjectIdColumn } from "../orm";

import { LocationPointType } from "./LocationPointType";
import { Position } from "./Position";

@GObjectType("DropoffPosition")
@CDEntity("dropoffPositions")
export class DropoffPosition extends CDBaseEntity {
    @GField()
    @CDObjectIdColumn()
    @IsUUID("4")
    @Expose()
    public _id: string = uuid();

    @GField()
    @CDColumn()
    @IsUUID("4")
    @IsDefined()
    @Expose()
    public locationId: string;

    @GField()
    @CDColumn()
    @IsString()
    @IsDefined()
    @Expose()
    public name: string;

    @GField({ nullable: true })
    @CDColumn()
    @IsString()
    @Expose()
    public label?: string;

    @GField(() => Position)
    @CDColumn()
    @IsDefined()
    @Expose()
    @Type(() => Position)
    public position: Position;

    @GField({ nullable: true })
    @CDColumn()
    @IsString()
    @Expose()
    @Transform((value?: string) => (value?.trim().length ? value : undefined))
    public imageUrl?: string;

    @GField({ nullable: true })
    @CDColumn()
    @IsString()
    @Expose()
    @Transform((value?: string) => (value?.trim().length ? value : undefined))
    public googleMapsUrl?: string;

    @GField({ nullable: true })
    @CDColumn()
    @IsString()
    @Expose()
    @Transform((value?: string) => (value?.trim().length ? value : undefined))
    public messageToCustomer?: string;

    @GField(() => GInt, { nullable: true })
    @CDColumn()
    @Expose()
    public addressType?: LocationPointAddressType;

    @CDColumn()
    @IsBoolean()
    @Expose()
    public displayOnlyMessageToCustomer: boolean = false;

    @CDColumn()
    @IsString()
    @Expose()
    @Transform((value?: string) => (value?.trim().length ? value : undefined))
    public messageToDriver?: string;

    @GField(() => GInt, { nullable: true })
    @CDColumn()
    @IsInt()
    @Expose()
    public policy?: LocationPointPolicy;

    @GField(() => GInt, { nullable: true })
    @CDColumn()
    @IsInt()
    @Expose()
    public type: LocationPointType;
}
